import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import colors from "../../constants/colors";

//Assets
import logo from "../../assets/logo_black.svg";
import link_small from "../../assets/icons/link_small.svg";
import cross_yellow from "../../assets/icons/cross_yellow.svg";
import wallet_yellow_menu from "../../assets/icons/wallet_yellow_menu.svg";

function MobileMenu({ closeMenu }: { closeMenu: () => void }) {
  type Options = "About & FAQ" | "Proxy Token" | "Assets";

  const [selectedItem, setselectedItem] = useState<Options>("About & FAQ");

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        max-height: 100vh;
        height: 100vh;
        position: fixed;
        background: ${colors.INTERFACE_COLORS_BASALT};
        z-index: 1000;
        flex-direction: column;
        align-items: center;
      `}
    >
      <span
        css={css`
          display: flex;
          width: 100%;
          position: absolute;
          margin-top: 8px;
          justify-content: space-between;
          align-items: center;
          padding: 0 16px;
        `}
      >
        <img
          onClick={closeMenu}
          css={css`
            width: 18px;
            height: 19px;
          `}
          src={cross_yellow}
          alt=""
        />
        <img
          css={css`
            width: 46px;
            height: 46px;
          `}
          src={wallet_yellow_menu}
          alt=""
        />
      </span>
      <span
        css={css`
          position: relative;
          display: flex;
          height: 120px;
          margin-top: 10vh;
        `}
      >
        <svg
          css={css`
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          `}
          width="109"
          height="97"
          viewBox="0 0 109 97"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M66.3458 1.62865C92.5277 8.6696 112.084 35.7033 107.831 63.0115C104.385 85.1394 74.322 82.0325 52.9478 87.6516C36.6899 91.9257 17.9997 102.52 7.52495 89.3813C-4.30142 74.5469 2.26469 53.4638 12.9654 37.4998C26.2414 17.6938 43.742 -4.45009 66.3458 1.62865Z"
            stroke="#FFD550"
          />
        </svg>
        <h1
          css={css`
            color: white;
            font-weight: 700;
            font-size: 56px;
          `}
        >
          Proxy
        </h1>
      </span>
      {/* Menu Items */}
      <span
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 16px;
        `}
      >
        {["About & FAQ", "Proxy Token", "Assets"].map((item) => {
          let selected = selectedItem === item;
          return (
            <span
              css={css`
                display: flex;
                align-items: center;
                position: relative;
                cursor: pointer;
              `}
              onClick={() => setselectedItem(item as Options)}
            >
              <RightArrow visible={selected} />
              <h3
                css={css`
                  opacity: ${selected ? 1 : 0.3};
                  color: ${selected
                    ? colors.INTERFACE_COLORS_LAVABEE_YELLOW
                    : colors.INTERFACE_COLORS_LIGHT_GRAY};
                  margin: 0;
                `}
              >
                {item}
              </h3>
            </span>
          );
        })}
      </span>
      {/* Connect Wallet */}
      <span
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 16px;
          margin-top: 18px;
        `}
      >
        <p
          css={css`
            font-weight: 700;
            font-size: 16px;
            margin: 0;
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            text-decoration: underline;
          `}
        >
          Connect you wallet
        </p>
        <p
          css={css`
            margin: 0;
            font-weight: 600;
            font-size: 16px;
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
          `}
        >
          to see Assets and Proxy Tokens
        </p>
      </span>
      {/* Other Links */}
      <span
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 48px;
          margin-top: 32px;
        `}
      >
        {["Pass", "Pulse"].map((item) => {
          let borderColor = colors.INTERFACE_COLORS_LIGHT_GRAY;
          return (
            <span
              css={css`
                display: flex;
                align-items: center;
                column-gap: 16px;
                cursor: pointer;
              `}
            >
              <p
                css={css`
                  font-weight: 700;
                  font-size: 56px;
                  margin: 0;
                  color: #000; /* Text color */
                  text-shadow: -1px -1px 0 ${borderColor},
                    1px -1px 0 ${borderColor}, -1px 1px 0 ${borderColor},
                    1px 1px 0 ${borderColor};
                `}
              >
                {item}
              </p>
              <img
                css={css`
                  filter: grayscale(1) invert(0.5);
                  width: 24px;
                  height: 24px;
                  margin-top: 8px;
                `}
                src={link_small}
                alt=""
              />
            </span>
          );
        })}
      </span>

      {/* Logo */}
      <img
        css={css`
          z-index: 1100;
          filter: invert(1);
          margin-top: auto;
          margin-bottom: 21px;
        `}
        src={logo}
        alt=""
      />
    </div>
  );
}

let RightArrow = ({ visible }: { visible: boolean }) => {
  if (!visible) {
    return <></>;
  }
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={css`
        width: 9px;
        height: 9px;
        position: absolute;
        left: -16px;
      `}
    >
      <path
        d="M2 2.18262L6.47834 6.66096L2 11.1393"
        stroke="#FFD550"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MobileMenu;
